import React, { useContext } from "react";
import Profile from "../../common/profile/Profile";
import Button from "../../common/button/Button";
import Card from "../../common/card/Card"
import { useNavigate } from 'react-router'
import Chip from "../../common/chip/Chip";
import Micromodal from 'micromodal'
import AddMemberModal from './Members/form/AddMemberModal'
import { addMemberModalId } from "./Members/form/Utils";
import { getPrettyUserMembershipStatus } from './ReportingGroup/utils'
import { useGroupDashboardContext } from "./GroupDashboardContext";
import { useParams } from 'react-router-dom'

const GroupDashboardCardBody = ( props: any ) => {

  const table = props.data ?? null
  const teamOptionsData = props.teamOptionsData
  const colors = [ '#AFECEF', '#FCD9BD', '#CDDBFE' ]
  const randomColor = Math.floor( Math.random() * colors.length )
  const notAllowedStatus = [ 'cancelled', 'expired', 'trash' ]
  const { setSelectedAddMemberModal, filtersData } = useGroupDashboardContext()

  const navigate = useNavigate()
  const handleEditTeam = ( id:number, canManage:boolean ) => {
    ( canManage )
      ? navigate(`/organization/${id}`)
      : navigate(`/organization/${id}/member-home`)
  }

  const params = useParams()
  tangibleFields.event('valueChange', field => {
    if ( !params.team_id && field.name === 'membersync_global_organization_switcher' ) {
      let currentID = field.value
      navigate(`/organization/${currentID}`)
    }
  })

  const handleAddMember = ( teamId:number, remainingSeatCount:number, seatCount:number, teamType:string ) => {
    const memberModalId = addMemberModalId(teamId)
    if ( teamType === 'wooteams' ) {
      setSelectedAddMemberModal({
        teamId: teamId,
        remainingSeats: remainingSeatCount,
        seatCount: seatCount,
        teamType: teamType
      })
    } else if ( teamType === 'msynclicenses' ) {
      setSelectedAddMemberModal({
        teamId: teamId,
        teamType: teamType
      })
    }
    Micromodal.show(memberModalId)
  }

  const tableRows = table.getRowModel().rows

  return (
    <>
      { table && tableRows.length !== 0
        ? tableRows.map( row => (
          <div className="msync-organization-dashboard-orgsListing__item" key={ row.id }>
            <div className={`msync-organization-dashboard-orgsListing__item__image msync-organization-dashboard-orgsListing__item__image--${ row.original.profile.length == 1 ? 'cover-photo' : 'users-profile' }`}>
              { row.original.profile && row.original.profile.length > 0
                ? row.original.profile.map( (cell, key) => (
                  <>
                  { key < 3 &&
                    <Profile
                        key={ cell.id }
                        src={ cell.src }
                        srcset={ cell.srcset }
                        size={ row.original.profile.length <= 1 ? '200px' : '96px' }
                        alt={ cell.name }
                        radius={ row.original.profile.length <= 1 ? 'radius-md' : 'radius-rounded' }
                        bgColor={ ! cell.src && ! cell.srcset ? colors[key] : cell.bgColor }
                        fontSize={ cell.fontSize }
                      />
                  }
                  { key == 3 &&
                    <div className='msync-avatar msync-avatar--radius-rounded' style={{width: '96px'}}>
                      <span 
                        className="msync-avatar__image msync-avatar__image--is-fallback" 
                        style={{backgroundColor: 'rgb(227, 228, 228)', color: 'rgb(68, 68, 70)'}}>
                          {`+${(row.original.members - 3)}`}
                      </span>
                    </div>
                  }
                  </>
                ))
                : <Profile
                    key={ row.original.teamId }
                    size={ "200px" }
                    alt={ row.original.title }
                    radius={ 'radius-md' }
                    bgColor={ colors[randomColor] }
                  />
              }    
            </div>
            <div className="msync-organization-dashboard-orgsListing__item__body">
              <div className="msync-organization-dashboard-orgsListing__item__body__content">
                <div className="msync-organization-dashboard-orgsListing__item__name msync-title msync-title--is-level-2">{ row.original.title }</div>
                <dl className="msync-organization-dashboard-orgsListing__item__meta">
                  <ul>
                    <li>
                      <dt>Members: </dt>
                      <dd>{ row.original.members }</dd>
                    </li>
                    <li>
                      <dt>Remaining Seats: </dt>
                      <dd>{ row.original.seatCount ? row.original.remainingSeatCount : 'Unlimited' }</dd>
                    </li>
                    <li>
                      <dt className="msync-visually-hidden">Your Role: </dt>
                      <dd>
                      <Chip type={
                        row.original.role === 'owner'
                        ? 'success'
                        : row.original.role === 'member'
                        ? 'primary'
                        : row.original.role === 'manager'
                        ? 'secondary'
                        : 'default'              
                      }> { row.original.role } </Chip>
                      { notAllowedStatus.includes(row.original.subscription.subscription_status) && (
                          <Chip type="error"> { row.original.subscription.subscription_status } </Chip>
                      )}
                      </dd>
                    </li>
                  </ul>
                </dl>
                
              </div>
              <div className="msync-organization-dashboard-orgsListing__item__body__actions">
                {/* This is replaced by Soft Launch Adjustment
                <Button
                  className="msync-primary-btn"
                  name="Buy licenses"
                  id={`group_dashboard_buy_licenses_${row.original.teamId}`}
                /> */}
                {
                  row.original.canManage &&
                  <>
                    {
                      notAllowedStatus.includes(row.original.subscription.subscription_status)
                      ? <button type='button' className='msync-btn msync-outline-primary-btn' disabled>Add member</button>
                      : <>
                          <Button
                            className="msync-button--is-style-outline msync-button--is-size-sm"
                            onClick={ () => handleAddMember( row.original.teamId, row.original.remainingSeatCount, row.original.seatCount, row.original.teamType ) }
                          >
                            Add Members
                          </Button>
                        </>
                    }
                  </>
                }
                <Button
                  id={`group_dashboard_edit_${row.original.teamId}`}
                  onClick={ () => handleEditTeam( row.original.teamId, row.original.canManage ) }
                  className={`msync-button--is-theme-secondary msync-button--is-style-outline msync-button--is-size-sm ${!row.original.canManage && 'msync-ml'} `}
                >
                  View
                </Button>
              </div>
            </div>
            {
              ! notAllowedStatus.includes(row.original.subscription.subscription_status) &&
              <AddMemberModal 
                key={`add-member-modal-${row.original.teamId}`} 
                isAdmin={ teamOptionsData.is_user_admin } 
                modalOption={ teamOptionsData.members_modal_option } 
                teamId={ row.original.teamId }
                navigateTo={`/organization/${row.original.teamId}/members`}
              />
            }
          </div>
        ))
        : <Card>
            <strong> No { filtersData['woo'].teams.plural_label.toLowerCase() } was found...</strong> 
          </Card>
      }
    </>
  )


}

export default GroupDashboardCardBody
